import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';

import { readMenuAll } from 'apis/restaurant-api/merchant-admin/menu2/api';
import { localize } from 'common/utils';

import { useProductInformationSettings } from './useProductInformationSettings';

export const useMenuItems = (menuId: string) => {
  const { locale } = useIntl();

  const { isFetching: isLoadingProductInformationSetting, errorProductInformationSettings } =
    useProductInformationSettings(menuId);

  const { data, isFetching, error } = useQuery(['read-menu-all', menuId], () => readMenuAll(menuId), {
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });

  const items = data?.items || [];

  const menuItems = items.map(item => ({
    ...item,
    name: localize(item.name, locale),
    description: localize(item.description, locale),
  }));

  return {
    menuItems,
    isLoadingMenuData: isFetching || isLoadingProductInformationSetting,
    hasErrorMenuData: error || errorProductInformationSettings,
  };
};
